const getWoosmapStoreInfos = idstore => new Promise(resolve => cube.stores.searchStores({ idstore }, resolve));

// Page account/mystore
const initMyStorePage = () => {
  const storeInfoBlock = cube.$id('mystore-page').$('.my-store');
  const storeId = storeInfoBlock && storeInfoBlock.dataset.storeId;

  if (storeId) getWoosmapStoreInfos(storeId).then(response => {
    const store = response[0].properties;

    storeInfoBlock.innerHTML = storeInfoBlock.innerHTML
      .replace('{{storeName}}', store.name||'')
      .replace('{{phone}}', store.contact.phone||'')
      .replace('{{addressLine1}}', store.address.lines[0]||'')
      .replace('{{addressLine2}}', store.address.lines[1]||'')
      .replace('{{addressZipCode}}', store.address.zipcode||'')
      .replace('{{addressCity}}', store.address.city||'')
      .replace('{{closingHour}}', (store.open.current_slice && store.open.current_slice.end)||'')
    ;

    if (store.open.open_now) storeInfoBlock.$('.is-closed').remove();
    else                     storeInfoBlock.$('.is-open').remove();

    storeInfoBlock.$$('.opening-days li').forEach((li, index) => {
      const day = store.weekly_opening[index + 1];

      let schedule = '';

      if (day.hours.length) {
        if (day.hours[0]) {
          schedule += day.hours[0].start;
          schedule += ' - ';
          schedule += day.hours[0].end;
        }

        if (day.hours[1]) {
          schedule += ' / ';
          schedule += day.hours[1].start;
          schedule += ' - ';
          schedule += day.hours[1].end;
        }
      }

      else schedule = storeInfoBlock.$('.opening-days').dataset.closedMessage;

      li.innerHTML = li.innerHTML.replace('{{schedule}}', schedule);
    });

    storeInfoBlock.classList.remove('loading');
  });
};


// Page account, block mystore
const initMyStoreBlock = () => {
  const storeInfoBlock = cube.$('[data-tracking="card-my-store"]');
  const storeId = storeInfoBlock && storeInfoBlock.dataset.storeId;

  if (storeId) getWoosmapStoreInfos(storeId).then(response => {
    const store = response[0].properties;

    if (store.open.open_now) {
      storeInfoBlock.innerHTML = storeInfoBlock.innerHTML.replace('{{openingHours}}', `${store.open.current_slice.start || ''} - ${store.open.current_slice.end || ''}`);
      storeInfoBlock.$('.is-closed').remove();
      storeInfoBlock.$('.is-open').style.display = 'block';
    }
    else {
      storeInfoBlock.$('.is-open').remove();
      storeInfoBlock.$('.is-closed').style.display = 'block';
    }

  });
};


export { initMyStorePage, initMyStoreBlock };



// WEBPACK FOOTER //
// ./src/customer/account/account-store.js